// extracted by css-extract-rspack-plugin
export default {"UpsellCardComponent":"xFIVb","Large":"Sc4Uf","MainStack":"zrDRG","UpsellCTALink":"iaEKF","Default":"dxVBn","Title":"JFW_v"};